import { Stack, useTheme } from "@mui/material";
import { HeartCheckIcon } from "Components/Shared/Icons";
import { InfoCard } from "Components/Shared/InfoCard/InfoCard";
import { AccountBalanceWallet, Savings } from "@mui/icons-material";
import { Resources, useResource } from "Translations/Resources";

const RESOURCES = Resources.Campaigns.Campaign.InfoCards;

type Props = {
  color?: string | null;
};

export const InfoCards = ({ color }: Props) => {
  const { t } = useResource();
  const theme = useTheme();
  const iconColor = color ?? theme.palette.primary.main;

  return (
    <Stack gap={3} mt={4}>
      <InfoCard
        title={t(RESOURCES.CreateAccountAndHelp.Title)}
        description={t(RESOURCES.CreateAccountAndHelp.Description)}
        icon={<Savings sx={{ fontSize: "54px", color: iconColor }} />}
      />
      <InfoCard
        title={t(RESOURCES.HelpingNeedy.Title)}
        description={t(RESOURCES.HelpingNeedy.Description)}
        icon={<HeartCheckIcon sx={{ fontSize: "50px", color: iconColor }} />}
      />
      <InfoCard
        title={t(RESOURCES.TestingPayment.Title)}
        description={t(RESOURCES.TestingPayment.Description)}
        icon={
          <AccountBalanceWallet sx={{ fontSize: "54px", color: iconColor }} />
        }
      />
    </Stack>
  );
};
